import { Component } from '@angular/core';

/**
 * アプリケーションコンポーネント
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent { }
